import React from "react";

const Brands = ({
  brands,
  setBrands,
  handleNext,
  handleSubmission,
  allBrands,
  isSmallScreen,
  loading,
}) => {
  const handleBrandClick = (brand) => {
    // If brand is already added, remove it; otherwise, add it
    if (brands.includes(brand.name)) {
      setBrands((prevBrands) =>
        prevBrands.filter((item) => item !== brand.name)
      );
    } else {
      setBrands((prevBrands) => [...prevBrands, brand.name]);
    }
  };
  const handleSubmitBrands = (e) => {
    e.preventDefault();
    // handleNext();
    handleSubmission(e);
  };

  return (
    <>
      <div
        className="text-center mb-4"
        style={{
          lineHeight: "0.5rem",
          paddingRight: isSmallScreen ? "2rem" : "4rem",
        }}
      >
        <h3
          style={{
            fontFamily: "Playfair Display",
            fontWeight: 600,
            fontSize: isSmallScreen ? "1.6rem" : "2rem",
          }}
        >
          What are your Favourite Brands?
        </h3>
        <p
          style={{
            fontFamily: "Open Sans",
            fontWeight: 400,
            fontSize: isSmallScreen ? "0.85rem" : "1.1rem",
            lineHeight: "1.5rem",
            padding: isSmallScreen ? "0rem" : "0rem 5.5rem",
          }}
        >
          Select the types of brands you love the most. This helps us recommend
          styles that match your vibe.
        </p>
      </div>
      <form onSubmit={(e) => handleSubmitBrands(e)}>
        <ul
          className={`list-inline d-flex flex-wrap gap-${
            isSmallScreen ? "2" : "3"
          } mb-3 justify-content-center`}
          style={{
            maxHeight: isSmallScreen ? "14rem" : "19.5rem",
            overflowY: "auto",
            padding: isSmallScreen
              ? "0rem 2rem 0rem 0rem"
              : "0rem 4rem 0rem 1.5rem",
          }}
        >
          {allBrands.map((brand, index) => (
            <li key={index} onClick={() => handleBrandClick(brand)}>
              <div
                className={`d-flex flex-column align-items-center gap-2 text-center hoverClass rounded-2`}
                style={{
                  width: isSmallScreen ? "4rem" : "5.1rem",
                  cursor: "pointer",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    zIndex: 10,
                    right: "0.2rem",
                  }}
                >
                  {brands.includes(brand.name) && (
                    <i className="bi bi-check-circle-fill text-primary fs-5"></i>
                  )}
                </div>

                <img
                  className={`rounded-2 position-relative avatar ${
                    isSmallScreen ? "avatar-lg" : "avatar-xl"
                  } border`}
                  src={brand?.logoUrl}
                  alt=""
                  loading="lazy"
                />
                <div
                  className="nav-item text-wrap h6 mb-0 fw-light"
                  style={{
                    wordWrap: "break-word",
                    fontSize: isSmallScreen ? "0.75rem" : "1rem",
                  }}
                >
                  {brand.label}
                </div>
              </div>
            </li>
          ))}
        </ul>
        <div
          className="d-grid mt-3"
          style={{ paddingRight: isSmallScreen ? "2rem" : "4rem" }}
        >
          <button
            type="submit"
            className="btn btn-primary flex-grow-1 rounded-3"
            disabled={brands.length < 3}
          >
            {loading ? (
              <div
                className="spinner-border text-white"
                style={{ width: "1rem", height: "1rem" }}
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : brands.length < 3 ? (
              `Select atleast ${3 - brands.length} ${
                brands.length !== 0 ? " more " : ""
              }`
            ) : (
              "Finish Registration"
            )}
          </button>
        </div>
      </form>
    </>
  );
};

export default Brands;
